import PokemonCard from './PokemonCard';
import CardsData from './ReadCardsData';

function App() {
    const cardsData = CardsData();
    if (!cardsData)
        return;

    console.log(cardsData[0]);

    const pokemonCards = cardsData.map((item, index) => {
        return <PokemonCard key={item.id} {...item} />
        //return <PokemonCard key={item.id} id={item.id} name={item.name} img={item.img} rarity={item.rarity} />
    });

    return (
        <div>
            <div>Lista de Cartas</div>

            <div>
                {pokemonCards}
            </div>
        </div>
    )
}


export default App;